import { render, staticRenderFns } from "./remind-score.vue?vue&type=template&id=44b825b5&scoped=true&"
import script from "./remind-score.vue?vue&type=script&lang=js&"
export * from "./remind-score.vue?vue&type=script&lang=js&"
import style0 from "./remind-score.vue?vue&type=style&index=0&id=44b825b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b825b5",
  null
  
)

export default component.exports